<template>
    <div>
        <vx-card title="Merchant Tree" collapse-action class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <tree id="tre-merchant" :data="originalData" draggable crossTree  ref="tree1" @change="tree1Change" >
                        <div v-bind:id="'tre-merchant-'+data.id" slot-scope="{data, level, store}">
                            <b v-if="data.children && data.children.length" @click="store.toggleOpen(data)"> {{data.open ? '-' : '+'}}</b>&nbsp;
                            <span> {{data.text}}</span>
                        </div>
                    </tree>
                </div>
            </div>
            <div class="w-full flex flex-no-wrap">&nbsp;</div>
            <div class="w-full flex flex-no-wrap text-right">
                <div class="w-1/2">
                    <vs-button id="btn-submit" v-if="validateRoles()" class="ml-4" @click="submitRecord">Save</vs-button>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import {DraggableTree} from "vue-draggable-nested-tree";
    import AxiosCall from "../../../global/AxiosCall";
    import {url} from "@/configs/apiUrl"

    export default {
        name: "TreeMerchant",
        components:{
            'tree':DraggableTree
        },
        data(){
            return {
                originalData: [],
                data: null,
                newData:[]
            }
        },
        methods: {
            getParent(root, id) {
                var node;

                root.some(function (n) {
                    console.log(n)
                    if (n.id === id) {
                        return node = n;
                    }
                    if (n.children) {
                        return node = this.getParent(n.children, id);
                    }
                });
                return node || null;
            },
            tree1Change(node, targetTree) {
                this.data = targetTree.getPureData()

                if (this.originalData.length > 1){
                    this.originalData = JSON.parse(localStorage.getItem("temp_data")).data
                }
                else {
                    let data = {}
                    data.data = this.data

                    localStorage.setItem("temp_data", JSON.stringify(data))
                }
                // this.newData = this.convertTreeToList(this.data)
                // let parent = this.getParent(this.newData, 98)
                // console.log(this.newData)
                // console.log(this.originalData)
                // console.log(this.originalData)
            },
            convertTreeToList(root) {
                var stack = [], array = [], hashMap = {};
                stack=root

                while (stack.length !== 0) {
                    var node = stack.pop();
                    if (node.children.length === 0) {
                        this.visitNode(node, hashMap, array);
                    } else {

                        for (var i = node.children.length - 1; i >= 0; i--) {
                            node.children[i].parent_id = node.id
                            stack.push(node.children[i]);

                            node.children.splice(i, 1)
                        }
                        stack.push(node)
                    }
                }
                return array;
            },
            visitNode(node, hashMap, array) {
                if (!hashMap[node.id]) {
                    hashMap[node.id] = true;
                    array.push(node);
                }
            },
            submitRecord(){
                let payload = {}
                payload.data = JSON.parse(localStorage.getItem("temp_data")).data

                AxiosCall.Post(url.svd.merchant.update_tree,payload ).then(resp=>{
                    if (resp.code === 200){
                        this.$vs.notify({
                            title: "Info",
                            text: "Update Tree Merchant success!",
                            iconPack: "feather",
                            icon: "icon-check-square",
                            color: "success",
                            position: "top-right"
                        });
                       this.getData()
                    }
                })
            },
            getData(){
                AxiosCall.Get(url.svd.merchant.tree+"?id="+this.$route.params.id).then(resp=>{
                    if (resp.code === 200){
                        this.originalData = resp.data
                        this.data = resp.data
                        let data = {}
                        data.data = resp.data
                        localStorage.setItem("temp_data", JSON.stringify(data))
                    }
                })
            },
            validateRoles() {
                const role = localStorage.getItem("userRole")
                return (role == 'root' || role == 'administrator' || role == 'aino_cc')
            }
        },
        created() {
           this.getData()
        }
    }
</script>

<style >
    .he-tree{
        border: 1px solid #ccc;
        padding: 20px;
        width: 100%;
    }
    .tree-node{
    }
    .tree-node-inner{
        padding: 5px;
        border: 1px solid #ccc;
        cursor: pointer;
    }
    .draggable-placeholder{
    }
    .draggable-placeholder-inner{
        border: 1px dashed #0088F8;
        box-sizing: border-box;
        background: rgba(0, 136, 249, 0.09);
        color: #0088f9;
        text-align: center;
        padding: 0;
        display: flex;
        align-items: center;
    }
</style>